import { createFeature, createReducer, on } from '@ngrx/store';

import { SharedDeliveryI } from '../../api/shared-delivery/shared-delivery.result.int';
import * as actions from './shared-delivery.actions';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';

export interface StateObjectI {
  data: SharedDeliveryI;
  errorMessage: string;
  loaded: boolean;
  loading: boolean;
}

export interface State {
  [SharedPageTypeEnum.infCnt]: StateObjectI;
  [SharedPageTypeEnum.rfrSet]: StateObjectI;
}

export const initialState: State = {
  [SharedPageTypeEnum.infCnt]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
  },
  [SharedPageTypeEnum.rfrSet]: {
    data: null,
    errorMessage: null,
    loaded: null,
    loading: null,
  },
};

export default createFeature({
  name: 'sharedDelivery',
  reducer: createReducer(
  initialState,
  on(actions.error, (state: State, { messageText, pageType }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loading: false,
      errorMessage: messageText
    }
  })),
  on(actions.load, (state: State, { pageType }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loaded: false,
      loading: true,
      data: null,
    }
  })),
  on(actions.received, (state: State, { data, pageType }): State => ({
    ...state,
    [pageType]: {
      ...state[pageType],
      loaded: true,
      loading: false,
      data,
    }
  })),
  on(actions.reset, (): State => ({
    ...initialState
  })),
)}
);